import { CompanyData } from '@types';
import { CompanyFormData } from './company-form';

export const companyDataPrepareForSubmit = (data: CompanyFormData): CompanyData => {
  const { receiptCertificates, ...rest } = data;
  const processedData = {
    ...rest,
    maxFLTravelAllowanceCents: toCentsOrUndefined(data.maxFLTravelAllowance),
    maxParkingCents: toCentsOrUndefined(data.maxParking),
    maxTWTravelAllowanceCents: toCentsOrUndefined(data.maxTWTravelAllowance),
    maxMileageAllowanceMeters: toNumberOrUndefined(data.maxMileageAllowance),
    receiptCertificateIds: receiptCertificates?.map((certificate) => certificate.id) ?? [],
  };

  return processedData;
};

const toNumberOrUndefined = (value: string | number | undefined): number | undefined => {
  if (value === '' || value === undefined) {
    return undefined;
  }
  return Number(value);
};

const toCentsOrUndefined = (value: string | number | undefined): number | undefined => {
  const numericValue = toNumberOrUndefined(value);
  return numericValue !== undefined ? numericValue * 100 : undefined;
};
